module.exports = __webpack_public_path__ + "img/americanexpress.14413865.png";